/**
 * @name ProtectedRoute
 * @description Componente para proteger rotas que requerem autenticação
 * @author Gabriel M. Guimarães | gabrielmg7
 */

import { useLoading } from '@/contexts/LoadingContext';
import useUserContext from '@/contexts/UserContext/useUserContext';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
     children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
     const { userSession } = useUserContext();
     const location = useLocation();
     const { loadingStates } = useLoading();

     // Loading durante verificação de autenticação - o loader global já cuida disso
     if (loadingStates['auth-loading']) {
          return null; // O loader global está ativo
     }

     // Se não está autenticado, redireciona para login
     if (!userSession) {
          return (
               <Navigate
                    to='/auth/login'
                    state={{ from: location.pathname }}
                    replace
               />
          );
     }

     return <>{children}</>;
};
